export default "__VITE_ASSET__db187fce__"